import { gfParseFieldValuesType } from '../gravity-forms-helpers/gf-parse-fieldvalues-type.helpers'

export const ga4GetFieldValue = (
  fieldId: number | string,
  fieldValues: object
) => {
  const value = gfParseFieldValuesType(fieldValues[fieldId])
  return value
}
